import { InitCookie } from '@patsnap/init-cookie';
import { initCookieService } from '@telecom/shared/utils/init-cookie.ts.ts';

export const VISITOR_ID_COOKIE_NAME = 'visitor_id';
export const VISITOR_ID_PREFIX = 'pt_';
export const VISITOR_ID_RANDOM_LENGTH = 29;
export const VISITOR_ID_COOKIE_MAX_AGE = 365 * 10 * 24 * 60 * 60;

/**
 * 生成用于调试游客身份的 visitor_id。
 */
export function createVisitorId(): string {
    const randomBytes = new Uint8Array(Math.ceil(VISITOR_ID_RANDOM_LENGTH / 2));
    crypto.getRandomValues(randomBytes);

    const randomPart = Array.from(randomBytes, byte => byte.toString(16).padStart(2, '0'))
        .join('')
        .slice(0, VISITOR_ID_RANDOM_LENGTH);

    return `${VISITOR_ID_PREFIX}${randomPart}`;
}

/**
 * 读取当前 visitor_id Cookie。
 */
export function getVisitorIdCookie(): string | undefined {
    return InitCookie.getVisitorId();
}

/**
 * 构造与 InitCookie 一致的 visitor_id Cookie 字符串。
 */
export function buildVisitorIdCookie(value: string, domain: string): string {
    const domainAttribute = domain ? `; domain=${domain}` : '';

    return `${VISITOR_ID_COOKIE_NAME}=${encodeURIComponent(value)}; path=/; max-age=${VISITOR_ID_COOKIE_MAX_AGE}${domainAttribute}`;
}

/**
 * 写入 visitor_id Cookie，并复用 InitCookie 的根域名规则。
 */
export function setVisitorIdCookie(value: string): void {
    const domain = initCookieService.initCookieIns.getRootDomain();
    document.cookie = buildVisitorIdCookie(value, domain);
}

/**
 * 清理当前页面可访问的 Cookie。
 */
export function clearAllCookies(): void {
    const cookieNames = document.cookie
        .split(';')
        .map(cookie => cookie.trim().split('=')[0])
        .filter(Boolean);
    const domain = initCookieService.initCookieIns.getRootDomain();

    cookieNames.forEach(name => {
        const expiredCookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 GMT; max-age=0; path=/`;
        document.cookie = expiredCookie;

        if (domain) {
            document.cookie = `${expiredCookie}; domain=${domain}`;
        }
    });
}
